import ("./src/styles/normalize.css");
import("./src/styles/variables.css");